// ============================================================
// src/lib/seller-checkout.ts
// ============================================================
import { postApi } from '@/lib/api';

export type PaymentStep = "pre_evaluation" | "publication";
export type UserType = "seller" | "broker";

interface CheckoutOptions {
  paymentStep: PaymentStep;
  userType: UserType;
  dealId?: string;
  email?: string;
}

interface CheckoutResponse {
  url: string;
  sessionId: string;
}

export const SELLER_PAYMENT_CONFIG = {
  PRE_EVALUATION: { amount: 300,  currency: "USD", description: "Deal Submission - Pre-evaluation" },
  PUBLICATION:    { amount: 2449, currency: "USD", description: "Deal Acceptance - Publication" },
  TOTAL: 2749,
};

export async function startSellerCheckout(options: CheckoutOptions): Promise<CheckoutResponse> {
  const { paymentStep, userType, dealId, email } = options;

  const data = await postApi('/payments/checkout', {
    type:        'one_time',
    planId:      'seller_pre_evaluation',
    priceId:     'price_1ScsbXCkUJGKtqQAHDOA1OcS',
    description: 'Deal Submission Fee',
    successUrl:  `${window.location.origin}${window.location.pathname}?payment=success`,
    cancelUrl:   `${window.location.origin}${window.location.pathname}?payment=canceled`,
  });

  if (!data?.url) throw new Error("No checkout URL returned");
  return { url: data.url, sessionId: data.sessionId };
}

export async function redirectToSellerCheckout(options: CheckoutOptions): Promise<void> {
  const { url } = await startSellerCheckout(options);
  window.location.assign(url);
}